import moment from 'moment';

import { EVV_FALLBACK_REASON_LABELS, EVV_FALLBACK_REASONS } from '../constants';

import type { EvvHistorySideStatus } from './types';

export function formatEvvDate(value: string | null | undefined) {
  return value ? moment.utc(value).format('MMM D, YYYY HH:mm:ss [UTC]') : '—';
}

export function getEvvFallbackReasonLabel(code: string) {
  const reason = Object.values(EVV_FALLBACK_REASONS).find((item) => item === code);
  return reason ? EVV_FALLBACK_REASON_LABELS[reason] : code;
}

export function formatEvvCaptured(captured: boolean, fallbackReason: string | null) {
  if (!captured) return 'No';
  return fallbackReason ? 'Yes (desktop)' : 'Yes';
}

export function formatEvvCaptureMethod(side: EvvHistorySideStatus) {
  if (!side.captured) return '—';
  return side.fallback_reason ? 'Desktop' : 'QR scan';
}
